import { render } from 'preact';
import { FlashCardArea } from './components/FlashCards';

const areaNodes = document.querySelectorAll('flash-card-area');
areaNodes.forEach(node => {
   const prefix = node.getAttribute('prefix') ?? "/";
   render(<FlashCardArea prefix={prefix} />, node);
});
